const React = require("react");
const {Drawer} = require("@material-ui/core");
const {Close: CloseIcon} = require("@material-ui/icons");
const AppIcon = require("../../../../../icons/Lunu");
const Navigation = require("../../Navigation");
const Ripple = require("../../../../../dumb/Ripple");
const {account$} = require("../../../../../../emitters/account");
const Tooltip = require('../../../../../dumb/Tooltip/B');
const {default: ExitToApp} = require("@material-ui/icons/ExitToApp");
const {MerchantSelect} = require("../../../../../dumb/FormInputs");
const {apiReloginMerchant} = require("../../../../../../api/_auth");
const BtnTableGlobal = require("../../../../../dumb/AdminHelpers/Buttons/components/BtnTableGlobal");

module.exports = ({isMenuOpen, toggleMenu}) => {
  const account = (account$.getValue() || {})
  const accountsList = account.accountsList || [];

  return (
    <Drawer open={isMenuOpen} onClose={toggleMenu}>
      <div className="w320 h layoutRow fxdC pl30 pr40">
        <div className="layoutRow aiC">
          <div className="pr20 mr10 crPointer" onClick={toggleMenu}>
            <CloseIcon />
          </div>
          <AppIcon className="w128 h80 rlv c0"/>
        </div>
        <div className="h1 bgDADCE1 w"/>
        <Navigation onClick={toggleMenu} />
        <div className="mtA">
          <div className="h1 bgDADCE1 w"/>
          <div className="wmax250 w h80 layoutRow jcSB aiC c0">
            <div className="wmax100%-55 w">
              {accountsList.length > 1
                ? (
                  <MerchantSelect
                    propName="login"
                    propValue="id"
                    items={accountsList}
                    value={account.id}
                    onChange={(name, val) => apiReloginMerchant({id: val})}
                  />
                ) : (
                  <Tooltip>{account.login}</Tooltip>
                )}
            </div>
            <div className="ml6">
              <BtnTableGlobal
                icon={ExitToApp}
                text="Exit"
                onClick={account.signOut}
              />
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  )
}
